import { createRoute, redirect } from '@tanstack/react-router'

import { createValidateSearch } from '@authy/lib-web/routes'
import { TRPCClientError, client } from '@authy/lib-client/trpc'
import { z } from '@authy/lib-common/utils/zod'

import { appRoute } from '@/app'

export const SearchSchema = z.object({
    token: z.string().min(1),
})

const validateSearch = createValidateSearch(SearchSchema)

export const invitationRoute = createRoute({
    getParentRoute: () => appRoute,
    path: '/invitation',
    validateSearch,
    beforeLoad: async ({ search, abortController }) => {
        try {
            const { tenantShortId } = await client.users.invitations.acceptInvitation.mutate(
                {
                    invitationToken: search.token,
                },
                { signal: abortController?.signal }
            )

            window.location.replace(`/${tenantShortId}`)

            await new Promise((resolve) => setTimeout(resolve, 5000))
        } catch (error) {
            if (error instanceof TRPCClientError) {
                const message = error.message
                const code = error.data?.code
                throw redirect({
                    replace: true,
                    to: '/error',
                    search: {
                        message,
                        code,
                    },
                })
            }

            throw error
        }
    },
})
